<template>
    <div>
        <kobra-search
            ref="kobrasearch"
            :search-query="searchQuery"
            :selected-kobra-info-type="selectedKobraInfoType"
            :selected-kobra-branch-group="selectedKobraBranchGroup"
            :selected-kobra-search-type="selectedKobraSearchType"
            :limit="100"
            :show-iframe="true"
            :show-infotypes="true" />
    </div>
</template>
<script>
    import Translator from 'tools/trans';
    import qs from 'qs';
    import { useGetters } from 'composables/useVuex';
    export default {
        name: 'KobraResults',
        data: function() {
            return {
                selectedKobraBranchGroup: null,
                selectedKobraInfoType: null,
                selectedKobraSearchType: null,
                searchQuery: this.query,
            };
        },
        watch: {
            selectedKobraBranchGroup() {
                this.updateKobraUriFromParameters();
            },
            selectedKobraInfoType() {
                this.updateKobraUriFromParameters();
            },
            selectedKobraSearchType() {
                this.updateKobraUriFromParameters();
            },
        },
        methods: {
            trans: Translator.trans,
            initKobra() {
                const element = document.getElementsByClassName('autoSearch__input');
                if (element.length > 0) {
                    this.searchQuery = element[0];
                }
            },
            updateKobraSearch() {
                this.$refs.kobrasearch.updateSearchResults();
                this.updateKobraUriFromParameters();
            },
            updateKobraUriFromParameters() {
                const parameters = qs.parse(window.location.search.substring(1));
                parameters.searchType = this.selectedKobraSearchType;
                parameters.branchGroup = this.selectedKobraBranchGroup;
                parameters.infoType = this.selectedKobraInfoType;
                parameters.q = this.searchQuery;

                history.pushState(null, null, `?${ qs.stringify(parameters) }#kobra`);
            },
        },
        setup() {
            const getters = {
                ...useGetters('search', [
                    'query',
                    'getShowSidebar']),
            };
            const query = getters.query;

            return {
                query,
            };
        },
    };
</script>
